import ActionsForm from '@/shared/mixins/actionsForm'
import PermissionMixin from '@/store/module/permission/mixin'
import AccountMixin from '@/store/module/account/mixin'
import CompanyMixin from '@/store/module/company/mixin'
import EnterpriseNewUnit from '@/shared/http/repositories/realestate/enterprisenewunit'
import { loading, toast } from '@/shared/utils/UIHelper'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
import { any } from 'underscore'
export default {
  name: 'ChangingNameTable',
  mixins: [AccountMixin, CompanyMixin, PermissionMixin, ActionsForm],
  data () {
    return {
      columns: ['NOME', 'APELIDO', 'STATUS', 'DT. DE CADASTRO', ''],
      // dataSearch: localStoreHelper.controleOcorrencia.nomeEmpreendimento() || {
      //   Empreendimentoid: null,
      //   Status: null
      // },
      ArrayEmpreendimentos: [],
      apelido: '',
      nome: '',
      FlagCriacao: null,
      nomeEmpreedimento: '',
      desabilitar: true,
      Id: null,
      empreedimento: '',
      result: null
    }
  },
  props: {
    dataSearch: {
      Type: Object,
      default: localStoreHelper.controleOcorrencia.nomeEmpreendimento() !== null || localStoreHelper.controleOcorrencia.nomeEmpreendimento() !== null ? localStoreHelper.controleOcorrencia.nomeEmpreendimento() : {
        Empreendimentoid: null,
        Status: null
      }
    }
  },
  watch: {
    'dataSearch': function () {
      this.Onload()
    },
    'apelido': function () {
      if (this.apelido === '') {
        this.desabilitar = true
      }
      if (this.apelido !== '') {
        this.desabilitar = false
      }
    },
    'nome': function () {
      if (this.nome === '') {
        this.desabilitar = true
      }
      if (this.nome !== '') {
        this.desabilitar = false
      }
    }
  },
  mounted () {
    this.Onload()
    this.result = this.dataSearch
  },
  methods: {
    Onload () {
      loading.push()
      let busca = localStoreHelper.controleOcorrencia.nomeEmpreendimento()
      if (busca !== any) {
        this.result = busca
      }
      EnterpriseNewUnit.GetEmpreendimentoNovaUnidade(this.$refs.tableNovaUnidade.pagingLimit, this.$refs.tableNovaUnidade.pagingIndex, this.result)
        .then((Response) => {
          this.ArrayEmpreendimentos = Response.data.data
          this.$refs.tableNovaUnidade.LoadAllByData(Response)
          loading.close()
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    openModalDelete (value) {
      if (value != null) {
        loading.push()
        EnterpriseNewUnit.UnidadeInativacao(value.id, 1)
          .then((Response) => {
            toast.success('Empreendimento Excluido')
            this.Onload()
            loading.pop()
          })
          .catch((Error) => {
            toast.error('Erro ao Excluido Empreendimento')
            loading.pop()
          })
      }
    },
    openModalActive (value) {
      if (value != null) {
        loading.push()
        EnterpriseNewUnit.UnidadeInativacao(value.id, 0)
          .then((Response) => {
            toast.success('Empreendimento Ativado')
            this.Onload()
            loading.pop()
          })
          .catch((Error) => {
            toast.error('Erro ao Ativar Empreendimento')
            loading.pop()
          })
      }
    },
    UpdateEmpApelido () {
      if (this.Id != null) {
        loading.push()
        EnterpriseNewUnit.UpdateApelido({EmpreendimentoUnidadeId: this.Id, Apelido: this.apelido})
          .then((Response) => {
            toast.success('Empreendimento Editado com sucesso')
            this.Onload()
            loading.pop()
            this.$refs['add-travel-modal-empreendimento'].hide()
            this.apelido = null
          })
          .catch((Error) => {
            toast.error('Erro ao Editar Empreendimento')
            loading.pop()
          })
      }
    },
    criacaoEmpreendimento () {
      loading.push()
      EnterpriseNewUnit.criacaoEmpreendimentonovaunidade({Apelido: this.apelido, Nome: this.nome})
        .then((Response) => {
          toast.success('Empreendimento Criado com sucesso')
          this.Onload()
          this.back()
          loading.pop()
        })
        .catch((Error) => {
          toast.error('Erro Criar Empreendimento')
          loading.pop()
          this.back()
        })
    },
    verificafluxo () {
      if (this.FlagCriacao === 1) {
        this.criacaoEmpreendimento()
      } else {
        this.UpdateEmpApelido()
      }
    },
    openModalEdit (value) {
      this.FlagCriacao = null
      this.nomeEmpreedimento = value.nomeEmpreendimento
      this.Id = value.id
      this.$refs['add-travel-modal-empreendimento'].show()
    },
    openModalInsert (value) {
      this.FlagCriacao = value
      this.Id = value.id
      this.$refs['add-travel-modal-empreendimento'].show()
    },
    back () {
      this.Id = null
      this.apelido = ''
      this.nome = ''
      this.$refs['add-travel-modal-empreendimento'].hide()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/ChangingNameBusiness/components/ChangingNameTable.js